
function PassValidation(passname){
    if(passname.length<6)
     return false;
    return true;
}
export default PassValidation;